import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import Home from './Pages/Home';

import Error404 from './Pages/Error404';
import Footer from './Component/Footer';
import Gallery from './Pages/Gallery';

function App() {
  return (
    <Router>
      <div className='d-flex flex-column min-vh-100'>
        <main className='flex-grow-1 pt-5 mt-3'>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/gallery' element={<Gallery />} />
            <Route path='*' element={<Error404 />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
